module.exports = __webpack_public_path__ + "static/media/mercadolivre-alpha.1fe622e6.png";